import { render, staticRenderFns } from "./getDelayReductionConf.vue?vue&type=template&id=5fa88cc8&scoped=true&"
import script from "./getDelayReductionConf.vue?vue&type=script&lang=js&"
export * from "./getDelayReductionConf.vue?vue&type=script&lang=js&"
import style0 from "./getDelayReductionConf.vue?vue&type=style&index=0&id=5fa88cc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa88cc8",
  null
  
)

export default component.exports